import {
  ButtonSecondary,
  IconInstagram,
  IconTwitter,
  IconFacebook,
  IconYoutube,
  cssColorValue,
  spacer16,
  semanticColors,
  screenMdMin,
} from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';

import { MastheadFooterData } from 'lib/sanity/types';

const SocialContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: ${spacer16};

  @media (min-width: ${screenMdMin}) {
    flex: 1 1 auto;
    justify-content: flex-end;
  }
`;

const StyledButtonSecondary = styled(ButtonSecondary)`
  color: ${cssColorValue(semanticColors.textBase)} !important;

  &:hover {
    border-color: ${cssColorValue(semanticColors.textBase)};
  }
`;

const PlatformIcons: Record<string, typeof IconTwitter> = {
  x: IconTwitter,
  instagram: IconInstagram,
  facebook: IconFacebook,
  youtube: IconYoutube,
};

interface Props {
  footerEntry: MastheadFooterData;
}

export const FooterSocial = ({ footerEntry }: Props) => {
  const { social } = footerEntry;
  if (social) {
    return (
      <SocialContainer>
        {social.map(({ href, target, variant, title, socialPlatform }, i) => {
          const PlatformIcon = socialPlatform ? PlatformIcons[socialPlatform] : null;
          if (variant === 'socialIcon' && PlatformIcon) {
            return (
              <StyledButtonSecondary
                key={i}
                href={href}
                target={target}
                iconOnly={PlatformIcon}
                data-testid={`footer-${socialPlatform}`}
                aria-label={title}
              />
            );
          }
          return null;
        })}
      </SocialContainer>
    );
  }

  return null;
};
